import { Component, Inject, OnDestroy, OnInit, TemplateRef } from '@angular/core';

//service 
import { OnlineVehiclesService } from "../../services/onlineVehicles.service";
import { LocalizePipe } from "../../pipes/Localize.pipe";

// data Models
import { IErrorHandlerToken, IErrorHandler } from "../../dataModels";
import { Configuration } from '../../configurations/shared.config';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
	selector: 'app-online-vehicles-counter',
	templateUrl: 'OnlineVehicles.component.html',
	styleUrls: ['OnlineVehicles.component.scss']
})
export class onlineVehiclesComponent implements OnInit, OnDestroy {
	onlineVehiclesNo: number = 0;
	intervalTimerToRefresh: number = Configuration.intervalTimerToGetOrderList;
	intervalRefresh: any;
	onlineVehiclesCountIsRetreved: boolean = true;
	vehiclesDetailsResponse: any = {};
	modalRef: BsModalRef;
	constructor(
		private onlineVehiclesService: OnlineVehiclesService,
		@Inject(IErrorHandlerToken) private errorHandler: IErrorHandler,
		private modalService: BsModalService,
		private localizer: LocalizePipe) { }

	ngOnInit() {
		this.getOnlineVehicles();
	}

	getOnlineVehicles(loader: boolean = true) {
		clearInterval(this.intervalRefresh);
		this.onlineVehiclesCountIsRetreved = false;
		this.onlineVehiclesService.getOnlineVehicles(loader).subscribe(res => {
			// console.log("res", res)
			if (!res.IsErrorState) {

				this.onlineVehiclesNo = res.Value;
				this.onlineVehiclesCountIsRetreved = true
				this.intervalRefresh = setInterval(() => {
					// console.log( "intervalRefresh before if" );
					if (this.onlineVehiclesCountIsRetreved) {
						// console.log( "intervalRefresh in if" );
						this.getOnlineVehicles(false);
					}
					this.onlineVehiclesCountIsRetreved = false;
				}, this.intervalTimerToRefresh);

			} else {
				this.errorHandler.Handle(this.localizer.transform(Configuration.messages.defaultErrorMessage));
			}
		})
	}


	openVehicleDetailsPopup(template: TemplateRef<any>) {

		this.modalRef = this.modalService.show(template, {
			class: 'modal-lg',
			backdrop: 'static',
			keyboard: false
		});
		this.getDetails();
	};

	getDetails() {
		this.onlineVehiclesService.getGetFreeVehiclesDetails().subscribe(res => {
			if (!res.IsErrorState) {

				this.vehiclesDetailsResponse = res;

			} else {
				this.errorHandler.Handle(this.localizer.transform(Configuration.messages.defaultErrorMessage));
			}
		})
	}

	closePopup() {
		this.vehiclesDetailsResponse = {};
		this.modalRef.hide();
	}
	ngOnDestroy() {
		clearInterval(this.intervalRefresh);

	}
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/OnlineVehicles/OnlineVehciles.component.ts